export const getDownloadTooltipText = (
  itemSelected,
  canBeDownloaded,
  downloadRule
) => {
  if (!itemSelected) {
    return "manageRepository.downloadTooltip.noItems";
  } else if (canBeDownloaded) {
    return "";
  } else {
    switch (downloadRule) {
      case "file":
      case "video":
      case "":
      case null:
        return "manageRepository.downloadTooltip.noUrl";
      default:
        return `manageRepository.downloadTooltip.${downloadRule}`;
    }
  }
};

export const showJobWarnings = response => {
  if (!response || !response.messages) {
    return;
  }
  const warningMessages = response.messages;
  if (!!warningMessages.message) {
    console.error(warningMessages.message);
  }
  if (warningMessages.warnings && warningMessages.warnings.length > 0) {
    warningMessages.warnings.forEach(msg => console.warn(msg));
  }
};
